import React from 'react';
import { Flex } from 'antd';

type WizardGutter = {
  narrowed: boolean;
  setNarrowed: (narrowed: boolean) => void;
};

const WizardGutterContext = React.createContext<WizardGutter>({
  narrowed: false,
  setNarrowed: () => undefined,
});

export function WizardGutterProvider({ children }: React.PropsWithChildren) {
  const [narrowed, setNarrowed] = React.useState(false);
  const gutter = React.useMemo(() => ({ narrowed, setNarrowed }), [narrowed]);

  return <WizardGutterContext.Provider value={gutter}>{children}</WizardGutterContext.Provider>;
}

export const useWizardGutter = (): WizardGutter => React.useContext(WizardGutterContext);

// FIXME: no exact token. The gutter is the least room the closed Nexus button needs beside the content.
const WIZARD_GUTTER = 140;
const NARROWED_WIZARD_GUTTER = 8;
const WIZARD_CONTENT_MAX_WIDTH = 1097;

export function WizardColumn({ children }: React.PropsWithChildren) {
  const { narrowed } = useWizardGutter();
  const gutter = narrowed ? NARROWED_WIZARD_GUTTER : WIZARD_GUTTER;

  return (
    <Flex
      vertical
      flex={1}
      style={{
        width: '100%',
        maxWidth: WIZARD_CONTENT_MAX_WIDTH + 2 * gutter,
        marginInline: 'auto',
        paddingInline: gutter,
        boxSizing: 'border-box',
      }}
    >
      {children}
    </Flex>
  );
}
